<template lang="pug">
.bet-slip
  template(v-if="filterMenu != 'transfer'")
    .stake-info-wrapper
      template(v-if="!status")
        .bet-status.lose(v-if="parseFloat(match.winlose) < 0")
          span {{ $t("ui.lose") }}
          span(v-if="uniqueID < 0") ({{ $t('ui.void') }})
        .bet-status.draw(v-else-if="parseFloat(match.winlose) == 0")
          span {{ $t("ui.draw") }}
          span(v-if="uniqueID < 0") ({{ $t('ui.void') }})
        .bet-status.won(v-else-if="parseFloat(match.winlose) > 0")
          span {{ $t("ui.win") }}
          span(v-if="uniqueID < 0") ({{ $t('ui.void') }})
      template(v-else)
        .bet-status(:class="match.bet_status.toLowerCase()")
          span {{ $t("ui." + match.bet_status.toLowerCase()) }}
      template(v-if="['sportsbook','adjustment','void'].includes(filterMenu)")
        template(v-if="['void'].includes(filterMenu)")
          .bet-status(:class="match.bet_status.toLowerCase()")
            //- span {{ $t("ui." + match.bet_status.toLowerCase()) }}
            span {{ (match.bet_status_code == 1) ? $t('ui.reject') : $t('ui.void') }}
        .bet-league
          img.icon.mr-1(:src="'/images/icon-sport-svg/' + getSportsImage(match)")
          template(v-if="racingList.includes(match.sports_type)")
            | {{ sports[match.sports_type] }}
          template(v-else)
            | {{ sports[match.sports_type] }} - {{ betType(match) }}
      template(v-else-if="filterMenu == 'livecasino'")
        .bet-league
          img.icon.mr-1(src="/images/icon-other/casino-icon.svg?v=12")
          | {{ $t("ui.casino") }}
      template(v-else-if="filterMenu == 'slots'")
        .bet-league
          img.icon.mr-1(src="/images/icon-other/slot-icon.svg?v=12")
          | {{ $t("ui.slots") }}
      template(v-else-if="filterMenu == 'esports2'")
        .bet-league
          img.icon.mr-1(src="/images/icon-sport-svg/20.svg?v=12")
          | {{ $t("ui.esports2") }}
      template(v-else-if="['tournament','tournament_refund'].includes(filterMenu)")
        .bet-status
          span {{ $t("ui.refund") }}
        .bet-league
          img.icon.mr-1(src="/images/icon-other/tournament.png?v=12")
          | {{ $t("ui.tournament") }}
      .stake-info(v-if="['sportsbook','adjustment','void'].includes(filterMenu)")
        .betslip-match
          .team-involved
            template(v-if="racingList.includes(match.sports_type)")
              template(v-if="racingList2.includes(match.sports_type)")
                template(v-if="['ML','1X2'].includes(match.bet_type)")
                  span {{ match.home_away == 1 ? getName(match, 1) : getName(match, 2) }}
                template(v-if="['OU','OE'].includes(match.bet_type)")
                  span {{ getName(match, 1) }}
                template(v-if="['CS'].includes(match.bet_type)")
                  span {{ ['5-0','4-1','3-2'].includes(match.criteria1) ? getName(match, 1) : getName(match, 2) }}
              template(v-else)
                span {{ getName(match, 1) }}
              span.small.ml-1(v-if="racingList.includes(match.sports_type) && match.match_time") (No. {{ $dayjs(match.match_time).format("MMDDhhmm") }})
            template(v-else) 
              template(v-if="match.bet_type != 'OR'")
                //- .score(v-if="match.market_type == 3 && match.home_running_score != null") {{ match.home_running_score + "-" + match.away_running_score }}
                //- template(v-if="!isStatement")
                //-   span(:class="match.home_giving == 1 && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 1) }}
                //-   span.vs - VS -
                //-   span(:class="match.home_giving == 0 && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 2) }}
                //- template(v-else)
                //-   span(:class="match.team_g == match.home_team_id && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 1) }}
                //-   span.vs - VS -
                //-   span(:class="match.team_g == match.away_team_id && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 2) }}
                .new
                  span.d-block {{ getName(match, 0) }}
                  template(v-if="!isStatement")
                    span.d-block(:class="match.home_giving == 1 && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 1) }}
                    span(:class="match.home_giving == 0 && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 2) }}
                  template(v-else)
                    span.d-block(:class="match.team_g == match.home_team_id && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 1) }}
                    span(:class="match.team_g == match.away_team_id && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 2) }}
              template(v-else)
                .score(v-if="match.home_score != null") {{ match.home_score }}
                span.team1 {{ getName(match, 1) }}
        .selector-odd.d-flex.justify-content-between
          template(v-if="racingList.includes(match.sports_type)")
            template(v-if="racingList1.includes(match.sports_type)")
              span.bet-type-text(v-if="['OU','OE'].includes(match.bet_type)") {{ $t("m.GH_" + match.bet_type + (match.home_away == undefined ? '' : match.home_away)) }}
              span.bet-type-text(v-else) {{ $t("m.GH_" + match.bet_type + (match.ball_home_3way == undefined ? '' : match.ball_home_3way)) }}
            template(v-if="racingList2.includes(match.sports_type)")
              span.bet-type-text(v-if="['OU','OE'].includes(match.bet_type)") {{ $t("m.GC_" + match.bet_type + (match.home_away == undefined ? '' : match.home_away)) }}
              span.bet-type-text(v-else-if="['CS'].includes(match.bet_type)") {{ match.criteria1 }}
              span.bet-type-text(v-else) {{ $t("m.GC_" + match.bet_type + (match.ball_home_3way == undefined ? '' : match.ball_home_3way)) }}
            template(v-if="racingList3.includes(match.sports_type)")
              span.bet-type-text(v-if="['OU','OE'].includes(match.bet_type)") {{ $t("m.GX_" + match.bet_type + (match.home_away == undefined ? '' : match.home_away)) }}
              span.bet-type-text(v-else) {{ $t("m.GX_" + match.bet_type + (match.ball_home_3way == undefined ? '' : match.ball_home_3way)) }}
            .bet-type-odds
              .odds
                span(:class="getNumberClass(match.odds_display)") {{ match.odds_display }}
          template(v-else)
            template(v-if="!isStatement")
              span.text(:class="isBallDisplay == false ? '' : ((match.home_giving == 0 && match.home_away == 2) ? 'team2' : (match.home_giving == 1 && match.home_away == 1) ? 'team2' : 'team1')") {{ match.market_type == 3 && match.home_running_score != null ? "[" + match.home_running_score + "-" + match.away_running_score + "]" : "" }} {{ match.bet_type }} | {{ betDisplay(match) }}
            template(v-else)
              span.text(:class="isBallDisplay == false ? '' : ((match.team_g == match.away_team_id && match.home_away == 2) ? 'team2' : (match.team_g == match.home_team_id && match.home_away == 1) ? 'team2' : 'team1')") {{ match.market_type == 3 && match.home_running_score != null ? "[" + match.home_running_score + "-" + match.away_running_score + "]" : "" }} {{ match.bet_type }} | {{ betDisplay(match) }}
            .bet-type-odds
              span.bet-type-text(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(match.bet_type)") {{ ballDisplay(match) }}
              .odds
                span(:class="getNumberClass(match.odds_display)") {{ match.odds_display }}
      .stake-info(v-else)
        template(v-if="['esports2'].includes(filterMenu)")
          .betslip-match
            .team-involved(v-if="match.game_type_name")
              span.mr-1 {{ match.game_type_name }}
              span(v-if="match.game_market_name") ({{ match.game_market_name }})
          .selector-odd
            .bet-type-odds
              span.text-danger.text-uppercase.mr-1 {{ match.bet_selection }}
              span.mr-1 {{ match.bet_type_name }}
              span.mr-1 @ {{ match.member_odds }}
        .betslip-match.others
          .game-name
            | {{ match.game_name }}
    .footer-slip.text-left
      .payout-wrapper
        .left
          | {{ $t("ui.stake") }}:
          span.ml-1(v-if="['sportsbook','adjustment', 'void'].includes(filterMenu)") {{ $numeral(match.bet_member).format("0,0.[00]") }}
          span.ml-1(v-else-if="['esports2'].includes(filterMenu)") {{ $numeral(match.bet_amount).format("0,0.[00]") }}
          span.ml-1(v-else) {{ $numeral(match.turnover).format("0,0.[00]") }}
        .right(v-if="!['Running', 'Waiting', 'Rejected'].includes(status)")
          template(v-if="match.winlose")
            template(v-if="match.payout || match.payout == 0")
              | {{ parseFloat(match.winlose) < 0 ? $t("ui.lose") : parseFloat(match.winlose) == 0 ? $t("ui.draw") : $t("ui.win") }}:
            template(v-else)
              | {{ $t("ui.payout") }}:
            span.ml-1(:class="match.winlose != 0 ? match.winlose > 0 ? 'win-amount' : 'lose-amount' : ''") {{ $numeral(match.winlose).format("0,0.00") }}
    .collapse(:id="'statement-child-' + uniqueID" :data-parent="'#statement-' + index")
      .bet-details-important(v-if="['sportsbook','adjustment', 'void'].includes(filterMenu)")
        .bet-details-league {{ getName(match, 0) }}
        template(v-if="![41, 42, 43, 44, 45, 46, 47, 49, 50, 51].includes(match.sports_type)") 
          .bet-details-result(v-if="match.home_score != null") {{ $t("ui.result") }}: {{ match.home_score + "-" + match.away_score }}
      .bet-details-important(v-else)
        template(v-if="['esports2'].includes(filterMenu)")
          .bet-details-league(v-if="match.event_name") {{ match.event_name }}
          .bet-details-result(v-if="match.competition_name") {{ match.competition_name }}
          .bet-details-result {{ $t("ui.result") }}:
            span.text-uppercase.ml-1 {{ match.result }}
        template(v-if="['tournament','tournament_refund'].includes(filterMenu)")
          .bet-details-league(v-if="match.remark") {{ $t('m.' + match.remark) }}
          .bet-details-result {{ $t('m.ROOM_T' + match.room_type) }} 
          .bet-details-result {{ $t('ui.room_id') }}: {{ match.room_id }}
        template(v-else)
          .bet-details-league {{ match.game_name }}
          .bet-details-result(v-if="!['DBP'].includes(match.game_provider)") {{ $t("ui.result") }}:
            span.result-icon.ml-1
              template(v-if="['AR', 'PGS', 'PP', 'JK', 'SP', 'JILI', 'PP-C', 'UU', 'NEXT', 'DB', 'WOW', 'AI', 'WF', 'OSG', 'EPW'].includes(match.game_provider)")
                template(v-if="match.game_provider == 'AR'")
                  a.icon-info(v-if="!loading.arcadia" href="javascript:void(0);" title='Result' @click="getResultAR(match.bet_id)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'PGS'")
                  a.icon-info(v-if="!loading.pgsoft" href="javascript:void(0);" title='Result' @click="getResultPGS(match.bet_id)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'PP'")
                  a.icon-info(v-if="!loading.pragmatic" href="javascript:void(0);" title='Result' @click="getResultPPG(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'JK'")
                  a.icon-info(v-if="!loading.joker" href="javascript:void(0);" title='Result' @click="getResultJKR(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'SP'")
                  a.icon-info(v-if="!loading.spp" href="javascript:void(0);" title='Result' @click="getResultSPP(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'JILI'")
                  a.icon-info(v-if="!loading.jili" href="javascript:void(0);" title='Result' @click="getResultJILI(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'PP-C'")
                  a.icon-info(v-if="!loading.lcppg" href="javascript:void(0);" title='Result' @click="getResultLCPPG(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'UU'")
                  a.icon-info(v-if="!loading.uusl" href="javascript:void(0);" title='Result' @click="getResultUUSL(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'NEXT'")
                  a.icon-info(v-if="!loading.next" href="javascript:void(0);" title='Result' @click="getResultNEXT(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'DB'")
                  a.icon-info(v-if="!loading.dbhash" href="javascript:void(0);" title='Result' @click="getResultDbHash(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'WOW'")
                  a.icon-info(v-if="!loading.wow" href="javascript:void(0);" title='Result' @click="getResultWOW(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'AI'")
                  a.icon-info(v-if="!loading.ai" href="javascript:void(0);" title='Result' @click="getResultAI(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'WF'")
                  a.icon-info(v-if="!loading.wf" href="javascript:void(0);" title='Result' @click="getResultWF(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'EPW'")
                  a.icon-info(v-if="!loading.epw" href="javascript:void(0);" title='Result' @click="getResultEPW(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
                template(v-if="match.game_provider == 'OSG'")
                  a.icon-info(v-if="!loading.live22" href="javascript:void(0);" title='Result' @click="getResultLive22Gaming(match)" target="_self")
                    i.fad.fa-chart-bar
                  span(v-else).fa.fa-spin.fa-spinner
              template(v-else)
                a.icon-info(:href="resultUrl(match)" title='Result' target="result" onclick="window.open(this.href,'result','top=10,height=600,width=400,status=no,toolbar=no,menubar=no,location=no');return false;")
                  i.fad.fa-chart-bar
                //- a.icon-info(v-if="!loading.live22" href="javascript:void(0);" title='Result' @click="getResultLive22Gaming(match)" target="_self")
                //-   i.fad.fa-chart-bar
                //- span(v-else).fa.fa-spin.fa-spinner
      .bet-details
        template(v-if="['tournament','tournament_refund'].includes(filterMenu)")
          .bet-details-row
            .left {{ $t("ui.points") }}: {{ $numeral(match.bet_payout).format("0,0.00") }}
            .right(v-if="match.jackpot_payout") {{ $t("ui.jackpot") }}: {{ $numeral(match.jackpot_payout).format("0,0.00") }} ({{ $t("ui.prize") }} x {{ $numeral(match.jackpot_value).format("0,0") }})
          .bet-details-row
            .left {{ $t("ui.ref_no") }}: {{ match.result_id }}
            .right {{ $t("ui.bet") }}: {{ $dayjs(match.bet_time).format("MM/DD/YYYY hh:mm:ss A") }}
        template(v-else)
          .bet-details-row
            .left {{ $t("ui.bet") }}: {{ match.created_on ? $dayjs(match.created_on).format("MM/DD/YYYY hh:mm:ss A") : $dayjs(match.bet_time).format("MM/DD/YYYY hh:mm:ss A")}}
            .right(v-if="['sportsbook','adjustment','void'].includes(filterMenu)") {{ $t("ui.event") }}: {{ $dayjs(match.match_time).format("MM/DD/YYYY hh:mm A") }}
          .bet-details-row(v-if="['sportsbook','adjustment', 'void', 'livecasino', 'esports2'].includes(filterMenu)")
            template(v-if="['esports2'].includes(filterMenu)")
              .left {{ $t("ui.comm") }}: {{ $numeral(match.comm).format("0,0.00") }}
              .right.text-uppercase(v-if="match.member_odds_style") {{ $t("ui.odds") }}: {{ match.member_odds_style }}
            template(v-else)
              .left {{ $t("ui.comm") }}: {{ $numeral(match.member_commission).format("0,0.00") }}
              .right(v-if="['sportsbook','adjustment','void'].includes(filterMenu)") {{ $t("ui.odds") }}: {{ $tc(odds[match.odds_type]) }}
          .bet-details-row
            .left ID: {{ ['sportsbook','adjustment','void'].includes(filterMenu) ? uniqueID < 0 ? match.ori_result_id + " (" + $t("ui.void").toUpperCase() + ")" : uniqueID : match.bet_id }}
            .right(v-if="['sportsbook','adjustment','void'].includes(filterMenu)") IP: {{ match.ip }}
    .btn-more-detail(:id="'statement-child-btn-' + uniqueID" data-toggle='collapse' :data-target="'#statement-child-' + uniqueID" aria-expanded='false' :aria-controls="'statement-child-' + uniqueID" @click="showDetail(match)") {{ $t("ui.more_details") }}
  template(v-else)
    .stake-info-wrapper
      .stake-info
        .betslip-match.others
          .settlement-amount.mr-1 {{ $t("ui.settled_amount") }}:
          span(:class="{ 'text-danger1': parseFloat(match.settled_amount) < 0 }") {{ $numeral(match.settled_amount).format("0,0.00") }}
</template>

<script>
import config from "@/config";
import naming from "@/library/_name";

export default {
  props: {
    index: {
      type: Number
    },
    match: {
      type: [Object, Array]
    },
    filterMenu: {
      type: String,
      default: "sportsbook"
    },
    leagueList: {
      type: [Object, Array]
    },
    matchList: {
      type: [Object, Array]
    },
    status: {
      type: String,
      default: ""
    },
    isStatement: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: {
        arcadia: false,
        pgsoft: false,
        pragmatic: false,
        joker: false,
        spp: false,
        jili: false,
        lcppg: false,
        uusl: false,
        next: false,
        dbhash: false,
        wow: false,
        ai: false,
        live22: false,
        wf: false,
        epw: false
      }
    }
  },
  computed: {
    racingList() {
      return config.racingList;
    },
    racingList1() {
      return config.racingList1;
    },
    racingList2() {
      return config.racingList2;
    },
    racingList3() {
      return config.racingList3;
    },
    sports() {
      return this.$store.state.layout.sports;
    },
    odds() {
      return config.oddsTypeLocale;
    },
    language() {
      return this.$store.getters.language;
    },
    uniqueID() {
      if(this.match) {
        return this.match.result_id || this.match.bet_id
      }
    },
    isBallDisplay() {
      var result = naming.ballDisplay2(this.match.ball_display, this.match.home_giving, this.match.home_away, this.match.bet_type, this);
      if (["HDP", "HDPH"].includes(this.match.bet_type)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    currency_code() {
      return this.$store.getters.currencyCode;
    },
  },
  methods: {
    getName: function(match, mode) {
      let name = ""
      if(mode == 0) {
        if(['running', 'waiting', 'rejected'].includes(this.status)) {
          name = (match["name_" + this.language]) ? match["name_" + this.language] : match["league_name"];
        } else {
          this.leagueList.forEach(x => {
            if(x.league_id == match.league_id) {
              name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
            }
          })
        }
      } else {
        console.log(this.status)
        if(['running', 'waiting', 'rejected'].includes(this.status)) {
          if (mode == 1) {
            name = (match["home_name_" + this.language]) ? match["home_name_" + this.language] : match["home_team_name"];
          } else {
            name = (match["away_name_" + this.language]) ? match["away_name_" + this.language] : match["away_team_name"];
          }
        } else {
          this.matchList.forEach(y => {
            if(y.match_id == match.match_id) {
              if (mode == 1) {
                name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
              } else {
                name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
              }
            }
          })
        }
      }
      return name;
    },
    showDetail(match) {
      let id = "#statement-child-btn-" + this.uniqueID
      let isActive = $(id).hasClass('active')
      if($(".btn-more-detail").hasClass('active')) {
        $(".btn-more-detail").removeClass('active').text(this.$t("ui.more_details"))
      }

      if(isActive) {
        $(id).removeClass('active').text(this.$t("ui.more_details"))
      } else {
        $(id).addClass('active').text(this.$t("ui.hide"))
      }
    },
    resultUrl(e) {
      let mode = this.filterMenu;
      switch(mode) {
        case "slots":
          var result = config.r2ResultUrl() + e.bet_id
          if (e.bet_id.includes("LOSG_") || e.bet_id.includes("LCB_")) {
            result = config.r3ResultUrl() + e.bet_id
          }
          return result
        case "livecasino":
          var account_id = this.$store.getters.accountId
          var session_token = this.$store.getters.sessionToken
          var result = config.r1ResultUrl() + "result_id=" + e.result_id + "&login_id=" + account_id + "&auth_token=" + session_token
          return encodeURI(result);
      }
    },
    getResultLive22Gaming(e) {
      if (this.loading.live22) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        currency: this.currency_code,
      };
      this.loading.live22 = true;
      this.$http.post(config.live22Path, args).then(
        (res) => {
          this.loading.live22 = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultlive22", "top=10,height=400,width=640,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        (err) => {
          this.loading.live22 = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultAR(e) {
      if (this.loading.arcadia) return;
      var id = e.replace("AR_", "");
      // console.log(id);
      var url = "";
      const args = {
        cert: config.arcadeCert,
        transId: id.toString()
      };
      this.loading.arcadia = true;
      this.$http.post(config.arcadePath, args).then(
        res => {
          this.loading.arcadia = false;
          if (res.data) {
            url = res.data.url;
            if (url) {
              window.open(url, "resultar", "top=10,height=600,width=400,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.arcadia = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultPGS(e) {
      if (this.loading.pgsoft) return;
      var id = e;
      var url = "";
      const args = {
        resultid: id.toString(),
        language: "en"
      };
      this.loading.pgsoft = true;
      this.$http.post(config.pgsPath, args).then(
        res => {
          this.loading.pgsoft = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultpgs", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.pgsoft = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultPPG(e) {
      if (this.loading.pragmatic) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id
      };
      this.loading.pragmatic = true;
      this.$http.post(config.ppgPath, args).then(
        res => {
          this.loading.pragmatic = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultpgs", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.pragmatic = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultJKR(e) {
      if (this.loading.joker) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id
      };
      this.loading.joker = true;
      this.$http.post(config.jkrPath, args).then(
        res => {
          this.loading.joker = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultjkr", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.joker = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultSPP(e) {
      if (this.loading.spp) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        // userid: e.member_id
      };
      this.loading.spp = true;
      this.$http.post(config.sppPath, args).then(
        res => {
          this.loading.spp = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultspp", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.spp = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultJILI(e) {
      if (this.loading.jili) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        language: "en"
      };
      this.loading.jili = true;
      this.$http.post(config.jiliPath, args).then(
        res => {
          this.loading.jili = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultjili", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.jili = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultLCPPG(e) {
      if (this.loading.lcppg) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        language: "en"
      };
      this.loading.lcppg = true;
      this.$http.post(config.lcppgPath, args).then(
        res => {
          this.loading.lcppg = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultlcppg", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.lcppg = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultUUSL(e) {
      if (this.loading.uusl) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString()
      };
      this.loading.uusl = true;
      this.$http.post(config.uuslPath, args).then(
        res => {
          this.loading.uusl = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultuusl", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.uusl = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultNEXT(e) {
      if (this.loading.next) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString()
      };
      this.loading.next = true;
      this.$http.post(config.nextPath, args).then(
        res => {
          this.loading.next = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultnext", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.next = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultDbHash(e) {
      if (this.loading.dbhash) return;
      this.loading.dbhash = true;
      var url = config.dbhashPath + "?result_id=" + e.bet_id.toString() + "&auth_token=" + this.$store.getters.sessionToken + "&login_id=" + e.member_id;
      this.loading.dbhash = false;
      window.open(url, "resultdbhash", "top=10,height=600,width=320,status=no,toolbar=no,menubar=no,location=no");
    },
    getResultWOW(e) {
      if (this.loading.wow) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        language: this.language
      };
      this.loading.wow = true;
      this.$http.post(config.wowgamingPath, args).then(
        res => {
          this.loading.wow = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultnext", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.wow = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultAI(e) {
      if (this.loading.ai) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        language: this.language
      };
      this.loading.ai = true;
      this.$http.post(config.aicasinoPath, args).then(
        res => {
          this.loading.ai = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultnext", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.ai = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultEPW(e) {
      if (this.loading.epw) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        currency: this.currency_code
      };
      this.loading.epw = true;
      this.$http.post(config.epwPath, args).then(
        res => {
          this.loading.epw = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultwf", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.epw = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getSportsImage(e) {
      if(e.sports_type == -1) {
        e.sports_type = 1
      }
      return config.getSportsImage(e.sports_type);
    },
    betType(e) {
      return this.$t("m.BS_" + e.bet_type);
    },
    betDisplay(e) {
      return naming.betDisplay(e, this);
    },
    ballDisplay(e) {
      // if(e.ball_display) {
      if(!this.isStatement) {
        return naming.ballDisplay2(e.ball_display, e.home_giving, e.home_away, e.bet_type, this);
      } else {
        return naming.ballDisplay1(e, this);
      }
    },
    getNumberClass(e) {
      return parseFloat(e) >= 0 ? "" : "negetive";
    }
  }
}
</script>